
import React from "react";
import { LogoCarousel } from "../Effects/LogoCarousel";

export function LogoCarouselDemo() {
  return (
    <div className="space-y-8 py-24">
      <div className="w-full max-w-screen-lg mx-auto flex flex-col items-center space-y-8">
      <div className="text-center">
  <h2 className="text-3xl sm:text-4xl md:text-3xl lg:text-5xl font-bebas text-black text-transparent bg-clip-text bg-black">
    The Best We Work With
  </h2>
  <h1 className="mt-4 text-2xl sm:text-5xl md:text-3xl lg:text-2xl font-bebas text-transparent bg-clip-text bg-gray-300">
    Meet Our Top Partners
  </h1>
</div>


        <LogoCarousel columnCount={3} />
      </div>
    </div>
  );
}
